export default "__VITE_PUBLIC_ASSET__9449d2da__"